// extracted by mini-css-extract-plugin
export default {"container":"Application_container__RPStG","collapsed":"Application_collapsed__Kq28B","content":"Application_content__0+inT"};